import { render } from "./SignOutButton.vue?vue&type=template&id=a5f03e7c"
import script from "./SignOutButton.vue?vue&type=script&lang=js"
export * from "./SignOutButton.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\toru-ota\\source\\repos\\Marron\\Jarvis\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__